<template>
  <div class="sf-order-summary">
    <slot name="heading" v-bind="{ orderTitle, orderTitleLevel }">
      <div>
        <div v-if="order && order.shippingDetail" class="shippingItem">
          <span class="sf-radio__content">
            <h3>{{ $t('Shipping_title') }}</h3>
            <div v-if="order.shippingDetail.firstName || order.shippingDetail.lastName">{{ $t('order_shopping_firstname')
              }}：{{
              order.shippingDetail.firstName }} {{
              order.shippingDetail.lastName
              }}</div>
            <div v-if="order.shippingDetail.apartment">{{ $t('MyAccount_MyShippingDetails_HouseNumber') }}：{{
              order.shippingDetail.apartment }}</div>
            <div v-if="order.shippingDetail.street">{{ $t('MyAccount_MyShippingDetails_Street') }}：{{
              order.shippingDetail.street }}</div>
            <div v-if="order.shippingDetail.city">{{ $t('MyAccount_MyShippingDetails_City') }}：{{
              order.shippingDetail.city }}</div>
            <div v-if="order.shippingDetail.state">{{ $t('MyAccount_MyShippingDetails_State') }}：{{
              order.shippingDetail.state }}</div>
            <div v-if="order.shippingDetail.country">{{ $t('Country') }}：{{ $t(order.shippingDetail.country) }}</div>
            <div v-if="order.shippingDetail.zipCode">{{ $t('MyAccount_MyShippingDetails_Zip') }}：{{
              order.shippingDetail.zipCode }}</div>
            <div v-if="order.shippingDetail.phone">{{ $t('MyAccount_MyShippingDetails_Phone') }}：{{
              order.shippingDetail.phone }}</div>
          </span>
        </div>
      </div>
      <SfHeading :title="orderTitle" :level="orderTitleLevel"
        class="sf-heading--left sf-heading--no-underline sf-order-summary__heading" />
    </slot>
    <div class="highlighted highlighted--total desktop-only">
      <slot name="summary" v-bind="{
        totalItems,
        subtotal,
        total,
        shippingMethod,
        propertiesNames,
      }">
        <template v-if="showOrderSumPrice">
          <SfProperty :name="$t(propertiesNames[0])" :value="totalItems"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty :name="$t(propertiesNames[1])" :value="$n(subtotal, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty :name="$t(propertiesNames[2])" :value="$n(shippingMethod.price, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty v-if="shippingMethod.postTaxFee > 0" :name="$t(propertiesNames[3])"
            :value="$n(shippingMethod.postTaxFee, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty v-if="shippingMethod.insuranceFee > 0" :name="$t(propertiesNames[4])"
            :value="$n(shippingMethod.insuranceFee, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty v-if="shippingMethod.insuranceTaxFee > 0" :name="$t(propertiesNames[5])"
            :value="$n(shippingMethod.insuranceTaxFee, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfProperty v-if="discount > 0 && false" :name="$t(propertiesNames[6])"
            :value="'-' + $n(discount, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
          <SfDivider class="sf-order-summary__divider" />
          <SfProperty :name="$t(propertiesNames[7])" :value="$n(total, 'currency')"
            class="sf-property--full-width sf-property--large sf-order-summary__property" />
        </template>
      </slot>
    </div>
    <div class="highlighted sf-order-summary__promo-code">
      <slot name="promo" v-bind="{ promoCode }">
        <SfInput v-model="promoCode" name="promoCode" :placeholder="$t('Enter_promo_code')"
          class="sf-input--filled sf-order-summary__promo-code-input" />
        <SfButton class="sf-order-summary__promo-code-button" data-testid="apply-button"
          @click="$emit('click:apply-code')">
          {{ $t('Apply') }}
        </SfButton>
      </slot>
    </div>
    <div class="sf-order-summary__characteristics">
      <slot name="characteristics" v-bind="{ characteristics }">
        <!-- <SfCharacteristic v-for="characteristic in characteristics" :key="characteristic.title"
          :title="$t(characteristic.title)" :description="$t(characteristic.description)" :icon="characteristic.icon"
          size-icon="32px" color-icon="green-primary" class="sf-order-summary__characteristics-item">
        </SfCharacteristic> -->
      </slot>
    </div>
  </div>
</template>
<script>
import {
  SfHeading,
  SfButton,
  SfDivider,
  SfProperty,
  SfCharacteristic,
  SfInput,
  SfAddressPicker
} from '@storefront-ui/vue';
export default {
  name: 'OrderSummary',
  components: {
    SfHeading,
    SfButton,
    SfDivider,
    SfProperty,
    SfCharacteristic,
    SfInput,
    SfAddressPicker
  },
  props: {
    orderTitle: {
      type: String,
      default: 'Order review'
    },
    orderTitleLevel: {
      type: Number,
      default: 2
    },
    order: {
      type: Object,
      default: () => ({})
    },
    propertiesNames: {
      type: Array,
      default: () => ['Products', 'Subtotal', 'Shipping', 'Shipping Tax', 'payment_insurance_fee', 'payment_insurance_tax', 'payment_order_discount', 'Total price']
    },
    characteristics: {
      type: Array,
      default: () => []
    },
    showOrderSumPrice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      promoCode: ''
    };
  },
  computed: {
    products() {
      return this.order.orderItems;
    },
    totalItems() {
      return this.products
        ? this.products.reduce((previous, current) => {
          return previous + current.qty;
        }, 0)
        : 0;
    },
    shipping() {
      return this.order.shipping || {};
    },
    discount() {
      return this?.order?.discount || 0;
    },
    shippingMethod() {
      return this.shipping.shippingMethod || { price: '', postTaxFee: '', insuranceFee: '', insuranceTaxFee: '' };
    },
    subtotal() {
      const products = this.products;
      const subtotal = this.products
        ? products.reduce((previous, current) => {
          const qty = current.qty;
          const price = current.price.special
            ? current.price.special
            : current.price.regular;
          const total = qty * parseFloat(price.replace('$', ''));
          return previous + total;
        }, 0)
        : 0;
      return subtotal.toFixed(2);
    },
    total() {
      const subtotal = parseFloat(this.subtotal.replace('$', ''));
      const shipping = parseFloat(this.shippingMethod.price.replace('$', ''));
      const shippingTax = parseFloat(this.shippingMethod.postTaxFee.replace('$', ''));
      const insuranceFee = parseFloat(this.shippingMethod.insuranceFee.replace('$', ''));
      const insuranceTaxFee = parseFloat(this.shippingMethod.insuranceTaxFee.replace('$', ''));
      // const discount = parseFloat(this.discount);
      const total = (subtotal + (isNaN(shipping) ? 0 : shipping) + (isNaN(shippingTax) ? 0 : shippingTax) + (isNaN(insuranceFee) ? 0 : insuranceFee) + (isNaN(insuranceTaxFee) ? 0 : insuranceTaxFee));
      return total.toFixed(2);
    }
  }
};
</script>
<style lang="scss">
#promoCode {
  border: 1px solid #1a1a1a;
  outline: none;
  height: 32px;
  line-height: 1;
}
.NewSummary{
  .sf-order-summary__prope{
    margin: var(--spacer-sm) 0 0 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.sf-heading__title {
  margin: var(--spacer-sm) 0 var(--spacer-sm) 0;
}

@import '~@storefront-ui/shared/styles/components/templates/SfOrderSummary.scss';
</style>
